import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";

const areas = [
  {
    number: "01",
    title: "Spine Care",
    text: "Focused care for the neck and back — from disc problems and stenosis to complex and revision spine surgery.",
    image: "https://readdy.ai/api/search-image?query=Photorealistic%20top%20down%20still%20life%20of%20a%20detailed%20spine%20model%20and%20a%20stethoscope%20on%20a%20clean%20white%20surface%20in%20a%20modern%20spine%20clinic%2C%20soft%20cyan%20and%20teal%20lighting%2C%20negative%20space%2C%20premium%20medical%20editorial%20photography&width=1000&height=750&seq=ospc-areacard-spine-2026&orientation=landscape",
    alt: "Spine care specialist reviewing spine imaging at Ortho Spine Care in Trichy",
    to: "/services/spine-care",
  },
  {
    number: "02",
    title: "Orthopaedic Care",
    text: "Treatment for bones, joints, muscles and ligaments — including joint replacement, arthroscopy and complex trauma.",
    image: "https://readdy.ai/api/search-image?query=Photorealistic%20arrangement%20of%20knee%20and%20hip%20joint%20models%20with%20an%20orthopaedic%20instrument%20on%20a%20clean%20white%20table%20in%20a%20modern%20clinic%2C%20soft%20royal%20blue%20and%20violet%20lighting%2C%20negative%20space%2C%20premium%20medical%20editorial%20photography&width=1000&height=750&seq=ospc-areacard-ortho-2026&orientation=landscape",
    alt: "Orthopaedic assessment of the joint and leg at Ortho Spine Care in Trichy",
    to: "/services/orthopaedic-care",
  },
];

export default function CareAreas() {
  return (
    <section id="care-areas" className="scroll-mt-28 bg-gradient-to-b from-background-50 to-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Areas of Care"
          title="Focused care, wherever you need it"
          description="We concentrate on the two areas where specialist experience matters most — the spine, and the muscles, bones and joints that keep you moving."
        />

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2">
          {areas.map((area) => (
            <Link
              key={area.title}
              to={area.to}
              className="reveal group relative flex h-[420px] cursor-pointer flex-col justify-end overflow-hidden rounded-2xl border border-background-200 transition-shadow duration-300 hover:shadow-[0_30px_60px_-40px_rgba(15,40,80,0.6)] md:h-[460px]"
            >
              <img
                src={area.image}
                alt={area.alt}
                title={`${area.title} — Ortho Spine Care Trichy`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div
                className="absolute inset-0 bg-gradient-to-t from-primary-950/92 via-primary-950/45 to-transparent"
                aria-hidden="true"
              ></div>
              <div className="relative p-6 md:p-7">
                <span className="bg-gradient-to-br from-primary-300 to-secondary-300 bg-clip-text font-heading text-3xl font-semibold text-transparent">{area.number}</span>
                <h3 className="mt-3 font-heading text-2xl font-semibold text-background-50">{area.title}</h3>
                <p className="mt-2.5 max-w-sm font-body text-sm leading-relaxed text-background-200">{area.text}</p>
                <span className="mt-5 inline-flex items-center gap-2 font-label text-sm font-semibold text-background-50">
                  Explore
                  <i
                    className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"
                    aria-hidden="true"
                  ></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}